import { ToastQueue } from '@wodi/ui';

/** One toast queue for the whole app, rendered by the root route. */
export const toasts = new ToastQueue();
